import { render, staticRenderFns } from "./LegoModalCheckList.vue?vue&type=template&id=52811768&scoped=true"
import script from "./LegoModalCheckList.vue?vue&type=script&lang=js"
export * from "./LegoModalCheckList.vue?vue&type=script&lang=js"
import style0 from "./LegoModalCheckList.vue?vue&type=style&index=0&id=52811768&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52811768",
  null
  
)

export default component.exports